var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',{staticClass:"cp-page__wrapper"},[_c('list-block',{attrs:{"repository":_vm.repository,"filter-settings":_vm.filterSettings},on:{"updateList":_vm.updateList,"resetFilters":_vm.resetFilters,"toAdd":_vm.toAdd}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }